// устаревшая хрень надо бы грохнуть но чот лень
//свернуть развернуть
//header = true иконка заголовка иначе иконка из списка
export function toggleElmnts(id, header) {
    let strClass = $('#' + id).find('i').attr('Class'),
        strStart = $('#' + id).find('i').attr('Class').indexOf(!header ? 'fa-toggle' : 'fa-chevron'),
        tStr = strClass.slice(strStart, strClass.length),
        strEnd = tStr.indexOf(' '),
        className = tStr.slice(0, (strEnd == -1 ? tStr.length : strEnd));

    if (!header) {
        if (className === 'fa-toggle-off')
            $('#' + id).find('i').removeClass('fa-toggle-off').addClass('fa-toggle-on');
        else
            $('#' + id).find('i').removeClass('fa-toggle-on').addClass('fa-toggle-off');
        event.stopPropagation();
    }
    else {
        if (className === 'fa-chevron-up')
            $('#' + id).find('i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        else
            $('#' + id).find('i').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        $('#list_collapse').toggle(200);
    }
}


var Map = (function () {
    const URL = "./ASPWebDataServise.asmx/",
        CORE = require('./core_last.js');
    var myMap, objectManager,
        list_history = {},
        listGroupCaption = [];

    /**
     * Метод для построения запросов на сервер
     * @param {any} url
     * @param {any} caption
     * @param {any} body
     */
    var _fetchAsync = async (url, caption, body = null) => {
        let jb = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        if (body !== null) {
            let sendJSON = JSON.stringify(body);
            jb.body = "{inputsParam:'" + sendJSON + "'}";

        }
        const promise = await fetch(url + caption, jb);
        return await promise.json();
    };

    /**
     * Преобразование адреса в координаты
     * @param {any} address
     */
    var _addressToCoord = async (address) => {
        let key = CORE.getApiKey();
        const url = 'https://geocode-maps.yandex.ru/1.x/?apikey='+key+'&format=json&geocode=' + address,

            promise = await fetch(url),
            responseData = await promise.json();

        try {
            debugger;
            return responseData.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ');
        }
        catch (err) {
            concole.table(err);
            return false;
        }
    };

    /**
     * Проставляем цвет меток
     * @param {any} vidId
     */
    var _getColor = vidId => {
        if (!vidId)
            vidId = 0;
        var id = parseInt(vidId);
        var colorArr = ['#4682B4', '#FF4500', '#8A2BE2', '#A52A2A', '#0000FF', '#5F9EA0',
            '#FF0000', '#2E8B57', '#6A5ACD', '#FF6347',
            '#00FFFF', '#00008B', '#008B8B', '#B8860B', '#006400',
            '#8B008B', '#556B2F', '#FF8C00', '#8B0000', '#483D8B',
            '#2F4F4F', '#1E90FF', '#228B22', '#FF00FF', '#FFD700',
            '#20B2AA', '#87CEFA', '#0000CD', '#9370DB', '#FFA500',
            '#7FFF00', '#D2691E', '#FF7F50', '#6495ED', '#DC143C'
        ];

        var color = colorArr[0];

        if (id >= colorArr.length) {
            var colorId = Math.floor(colorArr.length / id);
            color = colorArr[colorId];
        }
        else
            color = colorArr[id];
        return color;
    }

    /**
     * Разметка балуна 
     * @param {any} value
     */
    var rtrnBalun = value => {
        return `<div class="balun-content">
                 <div class="d-flex flex-column">
                    <div class="p-0 rbx-item-heder">${(value.naimk ? value.naimk : 'нет данных')}</div>
                    <div class="pl-2 rbx-item-addr">${(value.vidnkod ? value.vidnkod : 'нет данных')}</div>
                    <div class="pl-2 rbx-item-addr"><span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span>${value.fra_addr}</div>
                    <div class="pl-2 rbx-item-addr" > <span class="glyphicon glyphicon-phone-alt" aria-hidden="true"></span>${(value.ntel ? value.ntel : 'нет данных')}</div>
                    <div class="d-flex flex-row justify-content-center mt-2"><a href="./org_last.html?id=${value.id}" class="rbx-item-link pl-4"> <span class="glyphicon glyphicon-arrow-right" aria-hidden="true"></span>Перейти в паспорт поставщика</a></div>
                 </div>
               </div>`;
    }

    /**
     * Добавляем в objectManager обьект
     * @param {any} item
     * @param {any} arrPoint
     * @param {any} ind
     */
    var _createElemObjManager = (org, arrPoint, ind) => {
        if (!arrPoint) {
            CORE.stoptLoadingAnimation();
            console.error(`Не получены координаты для ${org.naimk}  => _createElemObjManager`);
            return false;
        }

        let geom = {
            type: 'Point',
            coordinates: [arrPoint[1], arrPoint[0]]
        },
            prpty = {
                id: org.id,
                balloonContent: rtrnBalun(org),
                //clusterCaption: '<a class=\"ssilka\">Организация № ' + (ind + 1) + ' </a>',
                hintContent: org.naimk ? org.naimk : 'нет данных',
                iconCaption: org.vidnkod ? org.vidnkod : org.naimk 
            },
            opt = {
                preset: 'islands#StretchyIcon',
                iconColor: _getColor(org.vidid),
                hideIconOnBalloonOpen: false
            },
            obj = {
                type: 'Feature',
                id: org.id,
                vid: org.vidid ? org.vidid : '0',
                geometry: geom,
                properties: prpty,
                options: opt
            };


        myMap.setCenter([arrPoint[1], arrPoint[0]], 8, {
            checkZoomRange: false
        });

        return obj;
    };

    /**
     * отрисовка элементов на карте
     * @param {any} response
     */
    var _setTargetInmap = response => {
        let a = JSON.parse(response.d);

        if (!a) {
            CORE.stoptLoadingAnimation();
            return
        };

        a.forEach((item, index) => {
            if (item.latitude == '' && item.longitude == '') {
                //вызываем сервис и пишем в базу
                let addres = item.fra_addr;

                if (addres === 'Адрес регистрации не заполнен' || addres == '') {
                    console.error(`У организации: ${item.naimk} c id=${item.id} не заполнен адресс: ${addres}`);
                    return false;
                }

                const promise = _addressToCoord(addres)
                    .then((arrPoint) => {
                        _fetchAsync(URL, 'SetContactCoordinate', {
                            orgId: item.id,
                            latitude: arrPoint[1],
                            longitude: arrPoint[0]
                        });
                        return arrPoint;
                    })
                    .then(arrPoint => objectManager.add(_createElemObjManager(item, arrPoint, index))//TO DO: проверить на ошибки не получения координат
                    );
            }
            else
                objectManager.add(_createElemObjManager(item, [item.longitude, item.latitude], index));
        });

        CORE.stoptLoadingAnimation();
    };

    /**
     * вспомогательный метод по отрисовке основного меню
     * @param {any} inputArr
     * @param {any} inputItem
     */
    var Unique = (inputArr, inputItem) => {
        for (var i = 0; i < inputArr.length; ++i) {
            var item = inputArr[i];
            if (item.k == inputItem.k)
                return false;
        }
        return true;
    }

    /**
      * отрисовать список организаций
      * @param {any} response
      */
    var _setListOrgForMaps = response => {
        let resp = JSON.parse(response.d);

        if (!resp) {
            CORE.stoptLoadingAnimation();
            return false;
        }

        $('.list_org__body').html('');
        $('.list_org_count').html(resp.length + ' организаций');

        resp.forEach((value) => {
            let txt = `<div class="org_card card" id="${value.id}"><div class="org_card_block card-block">
            <h6 class="org_card_title card-title">${value.naimk}</h6>
            <p class="card-text org-card-text" style="text-align:left">${value.fra_addr}</p>
            <p class="card-text org-card-text">Тел.: ${value.ntel}</p>
            <a href="./org_last.html?id=${value.id}" class="org-card-link">Подробнее</a></div ></div >`;

            $('.list_org__body').append(txt);
        })
        CORE.stoptLoadingAnimation();
    };

    /**
     * открыть окно с организациями по клику на главном меню
     * @param {any} id
     */
    var _openListForms = id => {
        CORE.startLoadingAnimation();
        let promise = _fetchAsync(URL, 'GetInfoListMaps', { vidId: id }).then(response => _setListOrgForMaps(response), error => console.error('Не удалось получить данные для отрисовки списка организаций'));

        $('.list_org_container').css('z-index', 998);
        $('.list_org_container').show(200);
    };

    /**
     * отрисовать главное меню
     * @param {any} response
     */
    var _setListVidOrgForMaps = response => {
        let a = JSON.parse(response.d);
        $('.list_type_org__body').html('');
        $('.list_type_org_count').html(a.length + ' видов организаций');

        if (!a) {
            CORE.stoptLoadingAnimation();
            return false;
        }

        //htmTxt += '<a class="small_link" id="small_link_' + value.vidid + '" onclick="maps.toggleElmnts(this.id, false)"> <i class="fa fa-toggle-on fa-2x" style="color:#004c8f" data-toggle="tooltip" data-html="true" title="Показать/Скрыть метки на карте"></i> </a>';
        a.forEach((value, index) => {
            let htmTxt = `<div class="small_card card" id="sm_sard_${index}">
                            <div class="small_card_block card-block">
                                <h6 class="card-title small_card_tittle" id="h_${value.vidid}">${value.vidnkod == '' ? 'Не указано' : value.vidnkod}</h6>
                                <p class="card-text small_card_text" id="pc_${value.vidid}">Всего организаций - ${value.kol}</p>
                                <p class="card-text small_card_text" id="p_${value.vidid}">Цвет меток
                                    <span id="sp_${value.vidid}" style="width: 2rem; border-radius: .5rem; height: 1rem; position:absolute; margin-left: 1rem; background:${_getColor(value.vidid)}"></span>
                                </p>
                            </div>
                        </div>`;

            // необходимо  для связи меток и меню
            var tData = {};
            tData.k = value.vidid;
            tData.v = value.vidnkod;

            if (Unique(listGroupCaption, tData)) {
                listGroupCaption.push(tData);
                list_history[tData.k] = true;
            }
            $('.list_type_org__body').append(htmTxt);
        });

        CORE.stoptLoadingAnimation();
    };

    /**
     * клик по главному меню
     * @param {any} e
     */
    var _typeOfOrganizationClick = e => {
        let tmpID = e.target.id;

        if (!tmpID)
            return false;

        let id = parseInt(tmpID.split('_')[1]);

        if (id)
            _openListForms(id);
    };

    /**
     *клик по организации второго меню
     * @param {any} e
     */
    var _organizationClick = e => {
        var id = ($(e.target).parent('div').parent('div').attr('id') == undefined ? $(e.target).parent('div').attr('id') : $(e.target).parent('div').parent('div').attr('id'));
        var objectState = objectManager.getObjectState(id);
        if (objectState.isClustered) {
            objectManager.clusters.state.set('activeObject', objectManager.objects.getById(id));
            objectManager.clusters.balloon.open(objectState.cluster.id);
        } else {
            objectManager.objects.balloon.open(id);
        }
    };

    var _closeForm = e => {
        $('.list_org_container').hide(400);
        $('.org_card').remove();
    }

    var _init = () => {
        // Создание экземпляра карты и его привязка к контейнеру с
        // заданным id ("map").
        myMap = new ymaps.Map('map', {
            // При инициализации карты обязательно нужно указать
            // её центр и коэффициент масштабирования.
            center: CORE.getCoord(),
            zoom: 8,
        }, {
                searchControlProvider: 'yandex#search'
            }
        );
        objectManager = new ymaps.ObjectManager({
            clusterize: true,
            gridSize: 64,
            clusterDisableClickZoom: true,
            clusterBalloonContentLayoutWidth: 400,
            clusterBalloonContentLayoutHeight: 250,
            clusterBalloonContentLayout: 'cluster#balloonCarousel',
        });

        myMap.geoObjects.add(objectManager); // так в примере   

        CORE.startLoadingAnimation();
        // отрисовка карты
        let strSearch = location.search.replace('?', ''),
            arrTmp = strSearch.split('&'),
            sendObj = {};

        if (arrTmp.length > 0) {
            arrTmp.forEach((item) => {
                let tmpItem = item.split('=');
                if (tmpItem[0] != "")
                    sendObj[tmpItem[0]] = tmpItem[1];
            });
        }

        let promise = _fetchAsync(URL, 'GetInfoListMaps', sendObj).then(response => _setTargetInmap(response), error => console.error('Не удалось получить данные для карты'))
            .then(a => {
                debugger;
                if (Object.entries(sendObj).length != 0)
                    objectManager.objects.balloon.open(sendObj.orgId);
            });

        if (Object.entries(sendObj).length === 0) {
            //отрисовка главного меню
            let mnuPromise = _fetchAsync(URL, 'GetListVidOrgForMaps', {}).then(response => _setListVidOrgForMaps(response), error => console.error('Не удалось получить данные для построения меню'));
            $('.list_type_org_container').show();
        }
        else {
            $('.list_type_org_container').hide();
        }
    };

    return {
        init: _init,
        typeOfOrganizationClick: _typeOfOrganizationClick,
        organizationClick: _organizationClick,
        closeForm: _closeForm
    };

    //#region возможно пригодится
    //// клик по иконке показать/скрыть, должна фильтртовать все метки по виду  
    //$('.small_link').on('click', function (e) {
    //    var id = this.id;

    //    var id_ = this.id.split('_');
    //    var id_item = id_[2];

    //    let strClass = $('#' + id).find('i').attr('Class'),
    //        strStart = $('#' + id).find('i').attr('Class').indexOf('fa-toggle'),
    //        tStr = strClass.slice(strStart, strClass.length),
    //        strEnd = tStr.indexOf(' '),
    //        className = tStr.slice(0, (strEnd == -1 ? tStr.length : strEnd));

    //    if (className === 'fa-toggle-off') {
    //        list_history[id_item] = false;
    //        objectManager.setFilter(
    //            getFilterFunction(list_history)
    //        );
    //    }
    //    else {
    //        list_history[id_item] = true;
    //        objectManager.setFilter(
    //            getFilterFunction(list_history)
    //        )
    //    }


    //    function getFilterFunction(categories) {
    //        return function (obj) {
    //            var content = obj.vid;
    //            return categories[content]
    //        }
    //    }
    //});
    //#endregion
}());

(function main() {
    $(document).mouseup(function (e) {
        var container = $('.list_org_container');
        if (container.has(e.target).length === 0) {
            $('.list_org_container').css('z-index', 996);
        }
        else {
            $('.list_org_container').css('z-index', 998);
        }
    });

    $("body").fadeIn(2000);

    $('.list_type_org_container').draggable();
    $('.list_org_container').draggable();

    ymaps.ready(Map.init);
    // клик по основному меню
    $('.list_type_org__body').on('click', Map.typeOfOrganizationClick);
    // клик по всплывшему меню организаций
    $('.list_org__body').on('click', Map.organizationClick);
    $('#closeForm').on('click', Map.closeForm);
}());